import React, { useEffect, useState } from 'react'
import { getCaddyMuster } from '../api/caddyAPI';

const CaddyMuster = (props) => {

    const [selectedFromDate,                    setSelectedFromDate]                    = useState(moment().toDate());
    const [selectedToDate,                      setSelectedToDate]                      = useState(moment().toDate());
    const [isInit,                              setIsInit]                              = useState(true);
    const [reportTable,                         setReportTable]                         = useState(null);
    const [caddyMuster,                         setCaddyMuster]                         = useState([]);

    useEffect(() => {         
        props.title("Muster", "caddy-muster")
        $('#txtFromDate').datepicker({
            format: 'dd-mm-yyyy',
            endDate: new Date(),
            autoclose: true,
        });  
        $('#txtFromDate').on('change', function (event) {
            setSelectedFromDate(event.target.value)
        }); 
        $('#txtToDate').datepicker({
            format: 'dd-mm-yyyy',
            autoclose: true,
        });  
        $('#txtToDate').on('change', function (event) {
            setSelectedToDate(event.target.value)
        }); 
    }, []);

    useEffect(() => {
        if (!isInit) fillDataTable();
    }, [caddyMuster])
    

    function exportSheet(type) {
    
        var fromDate = moment(selectedFromDate, 'DD/MM/YYYY').format("MM/DD/YYYY");
        var toDate   = moment(selectedToDate, 'DD/MM/YYYY').format("MM/DD/YYYY");
    
        reportTable.update({
            headers: true,
            formats: ["xlsx", "csv"],
            filename: `${fromDate} to ${toDate} - Caddy Report` // pass in a new set of properties
        });

        if (type == 'xlsx') {
            $('.button-default.xlsx').click();
        } else {
            $('.button-default.csv').click();
        }
        $('.tableexport-caption').addClass('hidden');
    }

    function fillDataTable() {

        const dataTable = $('#tblCaddyReport').KTDatatable({
            data: {
                saveState: false,
                source: caddyMuster,
                pageSize: 10
            },
            layout: {
                scroll: true,
                height: $(window).height() - 250,
                footer: false,
            },
            sortable: false,
            pagination: true,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field: 'Name',
                    title: 'Caddy Name',
                    template: function (row) {
                        return `<div class="kt-user-card-v2">
                                    <div class="kt-user-card-v2__pic">
                                        ${(row.Photo && row.Photo != '') ? `<img src="${row.Photo}" alt="event-thumbail" >` : ` <div class="kt-badge kt-badge--xl kt-badge--info">  ${row.Name.substring(0, 1)}</div>`}
                                    </div>
                                    <div class="kt-user-card-v2__details text-clip">
                                        <span class="kt-user-card-v2__name text-clip"> ${row.Name} </span> 
                                    </div>
                                </div>`
                    },
                },
                {
                    field: 'CaddyNumber',
                    title: 'Caddy Number',
                }, {
                    field: 'TotalDay',
                    title: 'Total Days',
                },
                {
                    field: 'TotalRound',
                    title: 'Total Rounds',
                    width: 90,
                    template: function (row) {
                        return `<center> ${row.TotalRound} </center>`
                    }
                },
                
            ]
        });

        //export to excel
        var fromDate = moment($('#txtFromDate').val(), 'DD/MM/YYYY').format("MM/DD/YYYY");
        var toDate   = moment($('#txtToDate').val(), 'DD/MM/YYYY').format("MM/DD/YYYY");

        const ReportTable = $('.kt-datatable__table').tableExport({
            formats: ["xlsx", "csv"],
            headers: true,
            filename: `${fromDate} to ${toDate} - Caddy Report`,
        });
        setReportTable(ReportTable);
        $('.tableexport-caption').addClass('hidden');
    }

    const getCaddyMusterHandler = async (e) => {
        try {
            const fromDate = moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
            const toDate = moment(selectedToDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
            const { caddyMuster } = await getCaddyMuster(fromDate, toDate);
            isInit ? setIsInit(false) : $('#tblCaddyReport').KTDatatable().destroy(); 
            setCaddyMuster(caddyMuster)
        } catch (err) {
            swal.fire({
                icon                : 'error',
                titleText           : 'Error!',
                text                : err.message,
                buttonsStyling      : false,
                confirmButtonClass  : 'btn btn-brand',
            }); 
        }
    }

    return (
        <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-b0" id="kt_content" style={{paddingTop: '0px'}}>
            <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                <div className="kt-portlet kt-portlet--mobile">
                    <div className="kt-portlet__body kt-portlet__body--fit padding-t20 padding-b0">
                        <div id="ControlHolder" className="kt-form kt-form--label-right padding-10 border-bottom-light" role="form">
                            <form id='get-report-form'>
                                <div className="row">
                                    <div className="form-group col-sm-1"></div>
                                    <div className="form-group col-sm-3">
                                        <div className="input-group date">
                                            <input 
                                                id="txtFromDate" 
                                                name="txtFromDate" 
                                                type="text" 
                                                className="form-control" 
                                                defaultValue={moment(selectedFromDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                                placeholder="Select date" 
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group col-sm-3">
                                        <div className="input-group date">
                                            <input 
                                                id="txtToDate" 
                                                name="txtToDate" 
                                                type="text" 
                                                className="form-control" 
                                                defaultValue={moment(selectedToDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                                placeholder="Select date" 
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group col-sm-1 vertical-center justify-content-start">
                                        <span 
                                            id="btnSearch" 
                                            className="btn btn-brand btn-sm "
                                            onClick={getCaddyMusterHandler}
                                        >Search
                                        </span>
                                    </div>
                                    <div id="exportContainer" className="form-group col-xl-1 col-sm-1 vertical-center">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button 
                                                    id="btn-export-excel" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('xlsx')}

                                                > Excel 
                                                </button>
                                                <button 
                                                    id="btn-export-csv" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('csv')}
                                                >  Csv </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </form>
                        </div>
                        <div id="tblCaddyReport" className="kt-datatable table-striped "></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CaddyMuster